/*** 主にデバッグ用 ***/
/** usage:
 * await sleep(1500); // 1.5sec
 **/
export const sleep = (duration: number): Promise<void> =>
  new Promise<void>((resolve) => setTimeout(resolve, duration));
